const TextField = (props) => {
	const ipgw_message_field = (e) => {
		if( '' != e.target.value ) {
			document.getElementById('ipgw_message_field').classList.add('is-active');
			window.setExtensionData('ipgw-invoice-payment-method-textfield','ipgw_payment_text_field', e.target.value);

		} else {
			document.getElementById('ipgw_message_field').classList.remove('is-active');
		}
	}
	if ( props.is_enabled === true ) {
		return (
			<>
				<div className="wc-block-components-text-input" id="ipgw_message_field">
					<input 
						type="text" 
						id="ipgw_rule_text_field" 
						name="name_ipgw_rule_text_field" 
						onChange={ipgw_message_field} 
					/>
					<label>Send Message to Admin (optional)</label>
				</div>
			</>
		)
	}
}

export default TextField
